import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'content-card',
    name: 'Content Card',
    description: 'To show long form contentClipped text in the card. Tape to open in long view ',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-content-card" */ "./ContentCardWidgetTemplate")),
    icon: generateIconProp('box'),
    complexity: 'easy',
});
